// n=8 élite (PR-N8-3) — Gráfico de líneas reutilizable (recharts) sobre un eje
// X de etiquetas + N series 0–10, con HUECOS (connectNulls=false → la línea se
// parte). En este PR alimenta solo la evolución INTRA-periodo (1 serie con la
// quick_note de cada sesión). N8-4 lo reusa para pilares + subgráficos.

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

export interface EvolutionSeriesInput {
  key: string;
  label: string;
  color: string;
  values: (number | null)[]; // alineado con points; null = hueco
}

interface Props {
  points: { label: string }[];
  series: EvolutionSeriesInput[];
  height?: number;
  yMin?: number;
}

export default function EvaluationEvolutionLines({
  points,
  series,
  height = 220,
  yMin = 0,
}: Props) {
  const data = points.map((pt, i) => {
    const row: Record<string, string | number | null> = { label: pt.label };
    for (const s of series) row[s.key] = s.values[i] ?? null;
    return row;
  });

  return (
    <div
      data-testid="evaluation-evolution"
      data-points={points.length}
      data-series={series.length}
      style={{ width: '100%', height }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 5, right: 10, left: -20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#2A2A2A" />
          <XAxis dataKey="label" stroke="#A0A0A0" fontSize={11} />
          <YAxis domain={[yMin, 10]} stroke="#A0A0A0" fontSize={11} allowDecimals={false} />
          <Tooltip
            contentStyle={{ background: '#1A1A1A', border: '1px solid #2A2A2A' }}
            labelStyle={{ color: '#fff' }}
          />
          {series.length > 1 && <Legend />}
          {series.map((s) => (
            <Line
              key={s.key}
              type="monotone"
              dataKey={s.key}
              name={s.label}
              stroke={s.color}
              strokeWidth={2}
              dot={{ r: 3 }}
              connectNulls={false}
              isAnimationActive={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
